import React from 'react';
import { Target, Globe, Users, Award } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';

const ABOUT_IMG = "https://images.unsplash.com/photo-1760246964044-1384f71665b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc2MDgxMTMwfDA&ixlib=rb-4.1.0&q=85";

export default function AboutSection() {
  const { t } = useLang();
  const values = [
    { icon: Target, title: t.about.mission, text: t.about.missionText },
    { icon: Globe, title: t.about.vision, text: t.about.visionText },
    { icon: Users, title: t.about.team, text: t.about.teamText },
    { icon: Award, title: t.about.excellence, text: t.about.excellenceText },
  ];

  return (
    <section id="apropos" data-testid="about-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-20">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#00D186] mb-4 block">{t.about.label}</span>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-tight text-[#0B132B] mb-6">
              {t.about.title1}<br /><span className="text-gradient">{t.about.title2}</span>
            </h2>
            <div className="space-y-4 text-base font-normal leading-relaxed text-[#475569]">
              <p>{t.about.p1}</p>
              <p>{t.about.p2}</p>
              <p>{t.about.p3}</p>
            </div>
          </div>
          <div>
            <div className="relative mb-8">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img src={ABOUT_IMG} alt="GIT NFT GHANA" className="w-full h-[350px] object-cover" />
              </div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#00D186]/10 rounded-2xl -z-10" />
              <div className="absolute -top-6 -right-6 w-24 h-24 border-2 border-[#0A75E5]/20 rounded-2xl -z-10" />
            </div>
            <div className="space-y-4 text-sm leading-relaxed text-[#475569]">
              <p>{t.about.p4}</p>
              <p>{t.about.p5}</p>
              <p>{t.about.p6}</p>
              <p>{t.about.p7}</p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((item, i) => (
            <div key={item.title} data-testid={`about-value-${i}`} className="bg-[#F3F5F7] rounded-xl p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group">
              <div className="w-12 h-12 rounded-lg bg-[#0B132B] flex items-center justify-center mb-5 group-hover:bg-[#00D186] transition-colors duration-300">
                <item.icon size={22} className="text-[#00D186] group-hover:text-[#0B132B] transition-colors duration-300" />
              </div>
              <h3 className="text-lg font-bold text-[#0B132B] mb-2">{item.title}</h3>
              <p className="text-sm text-[#475569] leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
